import authService from './authService';
import { navigate } from '@reach/router';
import ROUTES from '../routes';

type Message = {
  src: string;
  customToken: string;
  username?: string;
};

function isWatMessage(data: any): data is Message {
  return (
    data?.src === 'WAT' &&
    typeof data?.customToken === 'string' &&
    typeof data?.username === 'string'
  );
}

async function handleMessage(event: MessageEvent) {
  const data = event.data;
  if (data?.src !== 'WAT') {
    return;
  }

  if (!data?.username) {
    console.error('Username missing in postMessage payload');
    return;
  }

  if (isWatMessage(data)) {
    window.removeEventListener('message', handleMessage, false);
    await authService.signInWithCustomToken(data.customToken, data.username);
    await navigate(ROUTES.ACCOUNT);
  }
}

export function startPostMessageService() {
  if (typeof window !== 'undefined') {
    window.addEventListener('message', handleMessage, false);
  }
}
